/*
 * @Author: w
 * @Date: 2022-04-11 11:36:23
 * @LastEditors: w
 * @LastEditTime: 2022-05-13 16:10:18
 */
import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "@/stores";
import { useInfoStoreHook } from "@/stores/modules/login";
import Keycloak from "keycloak-js";
import {
  setToken,
  removeToken,
  getToken,
  setUserId,
  removeUserId,
  setRefreshToken,
  removeReFreshToken,
} from "@/scripts/token";
import "@/styles/global.styl";
import moment from "moment"; //导入模块
import "loaders.css";
import "element-plus/theme-chalk/display.css";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
moment.locale("zh-cn"); //设置语言 或 moment.lang('zh-cn');
var origin = window.location.origin;
if (process.env.NODE_ENV !== "production") {
  process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
}
const app = createApp(App);
app.config.globalProperties.$moment = moment;
function init() {
  app.component('QuillEditor', QuillEditor).use(store).use(router).mount("#app");
}
 //init()
if (window.location.href.indexOf("token") > 1) {
  let s = (location.href.split("?")[1] || "")
    .replace(/.+\?/, "")
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"');
  var obj = JSON.parse(s ? '{"' + s + '"}' : "{}");
  if (obj && obj?.token && obj?.refreshToken) {
    setToken(obj.token);
    setRefreshToken(obj?.refreshToken);
    init();
  }
  else {
    init()
  }
}
else{
  init()
}
//解决部署项目时自动缓存
const VUE_APP_VERSION = require("../package.json")?.version;
const vers = window.localStorage.getItem("appVersion");
console.log(VUE_APP_VERSION, vers)
if (VUE_APP_VERSION != vers) {
    window.localStorage.setItem("appVersion", VUE_APP_VERSION);
    location.reload();
}
